<template>
  <div class="order-success-massage" :class="getClass">
    <div class="order-success-massage_icon">!</div>
    <div class="order-success-massage_messages" v-html="getMessageHtml">
    </div>
  </div>
</template>

<script>
  import reduce from 'lodash/reduce'

  export default {
    name: 'SuccessMessage',
    props: {
      messages: {
        type: Array,
        default: () => []
      },
      classList: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      getClass: function () {
        return this.classList
      },
      getMessageHtml: function () {
        return reduce(this.messages, (r, e) => (r += e), '')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/SuccessMessage.vue